const transport = {
    truck: 'Camion',
    tractor: 'Tracteur'
} as { [key: string]: string }

export default transport
